import { Controller } from '@hotwired/stimulus'
import { markClean, markDirty } from '~/dirty_forms'

// F12: a changed, unsaved form asks before its changes are lost (guards in dirty_forms.ts); Ctrl/⌘+Enter saves.
// dirty: true = re-rendered with errors (422), the submitted values are still unsaved.
export default class DirtyFormController extends Controller<HTMLFormElement> {
  static override values = { message: String, dirty: Boolean }
  declare readonly messageValue: string
  declare readonly dirtyValue: boolean

  private readonly onChange = (): void => markDirty(this.element, this.messageValue)
  private readonly onSubmit = (): void => markClean(this.element)
  // A rejected save (422) can be morphed into this same form (I-UX-EDIT-01): no new connect, still unsaved.
  private readonly onSubmitEnd = (event: Event): void => {
    if (!(event as CustomEvent<{ success: boolean }>).detail.success) this.onChange()
  }

  override connect(): void {
    this.element.addEventListener('input', this.onChange)
    this.element.addEventListener('change', this.onChange)
    this.element.addEventListener('submit', this.onSubmit)
    this.element.addEventListener('turbo:submit-end', this.onSubmitEnd)
    if (this.dirtyValue) this.onChange()
  }

  override disconnect(): void {
    markClean(this.element)
  }

  submit(event: KeyboardEvent): void {
    event.preventDefault()
    this.element.requestSubmit()
  }
}
